import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateExamQuestionGroupsFragment = { __typename?: 'ExamQuestionGroup', id: number, positionA: number, positionB: number, positionsBookletA: Array<string>, positionsBookletB: Array<string> };

export type UpdateEqgPositionsMutationVariables = Types.Exact<{
  poolId: Types.Scalars['ID'];
  newPositions: Array<Types.ExamQuestionGroupInput> | Types.ExamQuestionGroupInput;
}>;


export type UpdateEqgPositionsMutation = { __typename?: 'Mutation', updateExamQuestionGroupPositions?: { __typename?: 'UpdateExamQuestionGroupPositionsPayload', successful: boolean, updatedExamQuestionsGroups?: Array<{ __typename?: 'ExamQuestionGroup', id: number, positionA: number, positionB: number, positionsBookletA: Array<string>, positionsBookletB: Array<string> }> | null } | null };

export const UpdateExamQuestionGroupsFragmentDoc = gql`
    fragment UpdateExamQuestionGroups on ExamQuestionGroup {
  id
  positionA
  positionB
  positionsBookletA
  positionsBookletB
}
    `;
export const UpdateEqgPositionsDocument = gql`
    mutation UpdateEQGPositions($poolId: ID!, $newPositions: [ExamQuestionGroupInput!]!) {
  updateExamQuestionGroupPositions(poolId: $poolId, newPositions: $newPositions) {
    successful
    updatedExamQuestionsGroups {
      ...UpdateExamQuestionGroups
    }
  }
}
    ${UpdateExamQuestionGroupsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEqgPositionsGQL extends Apollo.Mutation<UpdateEqgPositionsMutation, UpdateEqgPositionsMutationVariables> {
    document = UpdateEqgPositionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }